import actions from "./actions";

const initState = {
    forms: {},
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.UPDATE_FORMS:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    ...action.forms,
                },
            };
        case actions.FORM_SET_FORM_VALUE:
            state.forms[action.form].setFieldsValue({
                field: action.value,
            });
            return state;
        default:
            return state;
    }
}
